import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateChurch$ } from "../schemas/schemas_0";
export class CreateChurchCommand extends command(_ep0, _mw0, "CreateChurch", CreateChurch$) {
}
